import classNames from 'classnames';
import React from 'react';
import { ARIA_DISCLOSURE_ID_KEBAB } from '../../config/constants';
import useAriaDisclosure from '../../hooks/useAriaDisclosure';

import './style.scss';

const Kebab = ({ children, id, label }: {
  children: React.ReactNode;
  id?: number
  label?: string
}) => {
  const computedId = `${ARIA_DISCLOSURE_ID_KEBAB}-${id}`;
  const ariaDisclosure = useAriaDisclosure<HTMLDivElement>(computedId, {
    closeOnOutsideClick: true,
    closeOnEscape: true,
  });

  const classes = classNames('Kebab', {
    'Kebab--active': ariaDisclosure.isOpen,
  });

  return (
    <div className={classes}>
      <button
        aria-label={label}
        type="button"
        {...ariaDisclosure.toggleProps}
      >
        <i className="icon icon-dots icon-size-sm icon-variant-2" />&nbsp;
      </button>
      <div className="Kebab__children" ref={ariaDisclosure.targetRef} id={computedId}>
        { children }
      </div>
    </div>
  );
};

export default Kebab;
